export const compareDates = (date1: Date, date2: Date): number => {
  const day1 = date1.getDate();
  const month1 = date1.getMonth();
  const year1 = date1.getFullYear();

  const day2 = date2.getDate();
  const month2 = date2.getMonth();
  const year2 = date2.getFullYear();

  if (year1 !== year2) {
    return year1 - year2;
  }

  if (month1 !== month2) {
    return month1 - month2;
  }
  return day1 - day2;
};

export const toDateOnly = (date: Date) => {
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);
  return `${year}-${month}-${day}`;
};

export const daysInPeriod = (start: string, end: string): string[] => {
  const days: Date[] = [];
  const startDate = new Date(start);
  const endDate = new Date(end);
  const currentDate = new Date(startDate);

  while (currentDate <= endDate) {
    days.push(new Date(currentDate));
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return days.map((date) => toDateOnly(date));
};

export const weekRange = (targetDate: string | undefined, weekOffset = 0) => {
  const date = targetDate ? new Date(targetDate) : new Date();

  // set mid-day to avoid some edge cases in formatDate
  // FIXME this methods are very raw. Consider use a third part library
  date.setHours(12, 0, 0, 0);

  const dayOfWeek = date.getDay();

  const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;

  const monday = new Date(date);
  monday.setDate(date.getDate() + diffToMonday + weekOffset * 7);

  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);

  const formatDate = (d: Date) => d.toISOString().split('T')[0];

  const current = new Date(monday);

  const range = [];
  while (current <= sunday) {
    range.push(formatDate(current));
    current.setDate(current.getDate() + 1);
  }

  return {
    monday: formatDate(monday),
    sunday: formatDate(sunday),
    range,
  };
};
